import BookItem from "@app/components/book-item";
import Pagination from "@app/components/pagination";
import SkeletonGrid from "@app/components/skeleton-grid";
import {
  DEFAULT_PAGE,
  DEFAULT_REQUEST_PARAMS,
  RoutePath,
  TypeOfBookName,
  TypeOfBookValue,
} from "@app/constants";
import BookService from "@app/services/http/book.service";
import { Book, Meta, TypeOfBook } from "@app/types";
import { Images } from "@assets/images";
import useCancellationRequest from "@core/hooks/use-cancellation-request.hook";
import { RequestParams } from "@core/services/http/http.type";
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

function BookByType() {
  const [searchParams] = useSearchParams();
  const { abortController } = useCancellationRequest();

  const [books, setBooks] = useState<Book[]>([]);
  const [requestParams, setRequestParams] = useState<RequestParams>({
    ...DEFAULT_REQUEST_PARAMS,
    pageSize: 50,
  });
  const [meta, setMeta] = useState<Meta>();
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  useEffect(() => {
    const type = searchParams.get("type")
      ? String(searchParams.get("type"))
      : "";

    if (!Object.values(TypeOfBookValue).includes(type as any)) {
      navigate(RoutePath.HOME);

      return;
    }

    const typeOfBook = type as TypeOfBook;

    const newRequestParams: RequestParams = {
      ...requestParams,
    };

    BookService.getBooksByType(
      typeOfBook,
      newRequestParams,
      abortController.signal
    )
      .then((res) => {
        setBooks(res.data.items);
        setMeta(res.data.meta);

        if (
          requestParams.pageNum &&
          res.data.meta.totalPage > 0 &&
          res.data.meta.totalPage < requestParams.pageNum
        ) {
          const newRequestParams: RequestParams = {
            ...requestParams,
            pageNum: DEFAULT_PAGE,
          };

          setRequestParams(newRequestParams);
        }

        window.scrollTo({ top: 0, behavior: "smooth" });
      })
      .finally(() => {
        setLoading(false);
      });
  }, [searchParams.get("type"), requestParams]);

  const onPageChange = (page: number) => {
    const newRequestParams: RequestParams = {
      ...requestParams,
      pageNum: page,
    };

    setRequestParams(newRequestParams);
  };

  const getTitle = () => {
    const type = searchParams.get("type") as TypeOfBook;

    return TypeOfBookName[type];
  };

  return (
    <div className="px-[100px] min-h-[calc(100vh-328px)]">
      <div className="mt-[66px]">
        <div className="text-[#171A20] font-[SVN-Gilroy] font-bold text-[32px]">
          {getTitle()}
        </div>
      </div>
      {!loading && books.length ? (
        <div>
          <div className="mt-9 flex flex-wrap gap-6">
            {books.map((book) => (
              <div key={book.id}>
                <BookItem book={book} />
              </div>
            ))}
          </div>
          {meta && (
            <div className="flex justify-center mt-3">
              <Pagination
                currentPage={meta.pageNum}
                totalPages={meta.totalPage}
                onPageChange={onPageChange}
              />
            </div>
          )}
        </div>
      ) : !loading ? (
        <div className="mt-[164px] flex flex-col items-center">
          <img
            className="w-[120px]"
            src={Images.ResultNotFound.default}
            alt=""
          />
          <div className="font-[SVN-Gilroy] font-semibold tracking-[0.024px] text-[#171A20]">
            Không tìm thấy kết quả nào cho
          </div>
          <div className="font-[SVN-Gilroy] font-medium tracking-[0.024px] text-[#4E586C]">
            “{getTitle()}”
          </div>
        </div>
      ) : (
        <div className="mt-9">
          <SkeletonGrid />
        </div>
      )}
    </div>
  );
}

export default BookByType;
